export enum EEDIT_URLS {
    nonDeloitte = 'non-deloitte',
    memberFirm = 'member-firm',
    thirdParty = 'third-party',
}

export enum EREQUEST_ACTION{
    edit='edit',
    copy='copy',
}

export type IForm<T> = {
    [K in keyof T]?: any;
}
